import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import BackButton from "./BackButton";
import MarqueeBand from "./MarqueeBand";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen bg-white text-fegray-dark">
      <Header />
      <main className="pt-[90px] lg:pt-[128px]">
        <BackButton />
        {children}
      </main>
      <MarqueeBand />
      <Footer />
    </div>
  );
}
